export type FeedbackType = {
    id: number;
    name: string;
    cssClass?: string;
    icon?: string;
    color?: string;
};

export const FeedbackTypes: {
    LIKES: FeedbackType;
    IMPROVEMENTS: FeedbackType;
    SUGGESTIONS: FeedbackType;
    APPRECIATIONS: FeedbackType;
} = Object.freeze({
    LIKES: {
        id: 1,
        name: 'Gustos',
        cssClass: 'feedbacks-likes',
        icon: 'mdi-emoticon-happy-outline',
        color: '#60bb46',
    },
    IMPROVEMENTS: {
        id: 2,
        name: 'Mejoras',
        cssClass: 'feedbacks-improvements',
        icon: 'mdi-emoticon-sad-outline',
        color: '#ee1059',
    },
    SUGGESTIONS: {
        id: 3,
        name: 'Sugerencias',
        cssClass: 'feedbacks-suggestions',
        icon: 'mdi-message-text-outline',
        color: '#00aab8',
    },
    APPRECIATIONS: {
        id: 4,
        name: 'Valoraciones',
        cssClass: 'feedbacks-appreciations',
        icon: 'mdi-star-outline',
        color: '#f9a31b',
    },
});

export function getFeedbackType(name: string): FeedbackType {
    if (name === FeedbackTypes.LIKES.name) {
        return FeedbackTypes.LIKES;
    } else if (name === FeedbackTypes.APPRECIATIONS.name) {
        return FeedbackTypes.APPRECIATIONS;
    } else if (name === FeedbackTypes.IMPROVEMENTS.name) {
        return FeedbackTypes.IMPROVEMENTS;
    } else if (name === FeedbackTypes.SUGGESTIONS.name) {
        return FeedbackTypes.SUGGESTIONS;
    }

    return {
        id: -1,
        name: 'unknown',
    };
}
